import script from "./ConsentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentDetail.vue?vue&type=script&setup=true&lang=js"

import "./ConsentDetail.vue?vue&type=style&index=0&id=2837314b&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2837314b"]])

export default __exports__